export default "__VITE_ASSET__Dsa5MWAg__"